import { render, staticRenderFns } from "./LeagueTableEntryModal.vue?vue&type=template&id=67f6586d&"
import script from "./LeagueTableEntryModal.vue?vue&type=script&lang=js&"
export * from "./LeagueTableEntryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports